import { render, staticRenderFns } from "./ResultDetailCommunicationOutRight.vue?vue&type=template&id=f4ea67e0&scoped=true&"
import script from "./ResultDetailCommunicationOutRight.vue?vue&type=script&lang=js&"
export * from "./ResultDetailCommunicationOutRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ea67e0",
  null
  
)

export default component.exports